import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { ListEditorComponent } from './list-editor.component';
import { CommonModule } from '@angular/common';

import { TableModule } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { ButtonGroupModule } from 'primeng/buttongroup';
import { InputTextModule } from 'primeng/inputtext';
import { SelectModule} from 'primeng/select';
import { TooltipModule} from 'primeng/tooltip';
import { CheckboxModule } from 'primeng/checkbox';
import { FormsModule } from '@angular/forms';
import { FileUploadModule } from 'primeng/fileupload';
import { ToastModule } from 'primeng/toast';
import { ToolbarModule } from 'primeng/toolbar';
import { ToggleButtonModule } from 'primeng/togglebutton';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { InputNumberModule } from 'primeng/inputnumber';


import { NgStringPipesModule } from 'ngx-pipes';
import {SplitButtonModule} from 'primeng/splitbutton';
import {InputMaskModule} from 'primeng/inputmask';
import { MessageService } from 'primeng/api';
import { CommonCheckService } from 'FoxxyLib';

import { TransferDialogComponent } from '../components/transfer-dialog/transfer-dialog.component';

import { MoebelService } from 'FoxxyLib';

import { CommonDataModule } from 'FoxxyLib';
import { DatePickerModule } from 'primeng/datepicker';

@NgModule({
    imports: [CommonModule,  TableModule, FormsModule, ButtonModule, InputTextModule, TooltipModule,
        ButtonGroupModule ,
        DatePickerModule, CommonDataModule,
        CheckboxModule, FileUploadModule, ToastModule, NgStringPipesModule, ToolbarModule, ToggleButtonModule, ConfirmDialogModule, SplitButtonModule,
        SelectModule,   InputMaskModule, InputNumberModule ],
    exports: [ListEditorComponent],
    declarations: [ListEditorComponent, TransferDialogComponent],
    providers: [MessageService, CommonCheckService, MoebelService],
})
export class ListEditorModule { }
